module.exports = __webpack_public_path__ + "img/qr-loading.e22b3936.png";